/* SLIM-01 (24 Oct 2026): four scripts of sections/bd-v28-offer-grid.liquid that only add listeners or run at
   DOMContentLoaded / window load (toolkit URL, why-exclusive, offer scope, gallery thumbnails), moved out of the HTML
   unchanged and loaded with defer at the same spot. The section id comes from the script tag (data-root-id). */
(function () {
var BD_OG_ROOT_ID = (document.currentScript && document.currentScript.getAttribute('data-root-id')) || '';
/* URL-REVERT (24 Oct 2026, owner): choosing a format no longer writes ?toolkit= into the address (FRICTION-24 P2-2 removed).
   Incoming links with ?toolkit=<handle> still preselect that format (bd-product-v25.js / the offer-grid preselect). */
/* data-bd-why-exclusive */
(function () {
  var root = document.getElementById(BD_OG_ROOT_ID)
          || document.querySelector('[data-bdp-offer-grid]');
  if (!root) return;
  var why = root.querySelector('[data-bdp-why]');
  var tpl = root.querySelector('[data-bdp-specialist-options]');
  if (!why || !tpl) return;
  function sluitAnder(open, ander) {
    open.addEventListener('toggle', function () {
      if (open.open && ander.open) ander.open = false;
    });
  }
  sluitAnder(why, tpl);
  sluitAnder(tpl, why);
})();
/* data-bd-offer-scope-init */
(function () {
  var root = document.getElementById(BD_OG_ROOT_ID)
          || document.querySelector('[data-bdp-offer-grid]');
  if (!root) return;

  var DIGITAAL = ['digital access', 'sheets and miro', 'instant access'];
  var FYSIEK   = ['tracked delivery', 'shipping', 'return policy', 'dispatch'];

  function soortVanTitel(titel) {
    var t = (titel || '').toLowerCase();
    if (t.indexOf('complete') === 0 || t.indexOf('complete') > -1) return 'complete';
    if (t.indexOf('physical') > -1) return 'physical';
    if (t.indexOf('sheets') > -1 || t.indexOf('miro') > -1 || t.indexOf('template') > -1) return 'templates'; /* V2.6: losse templates (49 euro) zijn geen Digital App */
    return 'digital';
  }

  function raakt(tekst, lijst) {
    var t = (tekst || '').toLowerCase();
    for (var i = 0; i < lijst.length; i++) if (t.indexOf(lijst[i]) > -1) return true;
    return false;
  }

  function zetItem(el, tonen) {
    if (!el) return;
    if (tonen) { el.removeAttribute('data-bd-scope-hidden'); el.style.removeProperty('display'); }
    else { el.setAttribute('data-bd-scope-hidden', ''); el.style.setProperty('display', 'none', 'important'); }
  }

  function pasToe(soort) {
    document.documentElement.setAttribute('data-bd-selected', soort);
    var heeftDigitaal = soort !== 'physical';
    var heeftFysiek = soort === 'physical' || soort === 'complete';

    // vinkjesbalk onder het koopblok
    document.querySelectorAll('.bd-cx-reassure').forEach(function (strip) {
      [].slice.call(strip.children).forEach(function (item) {
        var tekst = item.textContent || '';
        if (raakt(tekst, DIGITAAL)) zetItem(item, heeftDigitaal);
        else if (raakt(tekst, FYSIEK)) zetItem(item, heeftFysiek);
      });
    });

    // cijferblok: bevat sinds 23 sep alleen cijfers die voor elk formaat gelden,
    // dus daar wordt niets meer verborgen (dat liet een lege kolom achter).
  }

  var titel = root.querySelector('[data-bdp-selected-title]');
  /* UPG-01 (22 Oct 2026, QA P2-3): the role comes from the selected SKU, so it also works on the German and French pages
     (their titles, e.g. "Tabellenvorlagen", fell through to "digital" and showed the Digital App's "For €80 more" upgrade);
     the Workbook is its own role (no upgrade block). The title stays as the fallback. */
  function rolVanKey(k) { return /WORKBOOK/.test(k) ? 'workbook' : /COMPLETE/.test(k) ? 'complete' : /PHYSICAL/.test(k) ? 'physical' : /SHEETS|MIRO/.test(k) ? 'templates' : /DIGITAL/.test(k) ? 'digital' : ''; }
  function nu() { var k = root.getAttribute('data-bdp-selected-key') || ''; pasToe(rolVanKey(k) || soortVanTitel(titel ? titel.textContent : '')); }
  window.bdOfferScope = nu; /* DEFER-01: re-applied after the lower sections are inserted (assets/bd-deferred-sections.js) */

  if (titel && window.MutationObserver) {
    new MutationObserver(function () { window.setTimeout(nu, 60); })
      .observe(titel, { childList: true, characterData: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', nu, { once: true });
  else nu();
})();
/* data-bd-gallery-thumbs-init */
(function () {
  // Dit script staat naast de <style> van de sectie en dus BUITEN de grid-div,
  // waardoor closest() niets vond. Daarom op id zoeken, met een vangnet.
  function zoekRoot() {
    return document.getElementById(BD_OG_ROOT_ID)
        || document.querySelector('[data-bdp-offer-grid]');
  }
  var root = zoekRoot();
  if (!root) return;
  var wrap = root.querySelector('[data-bdp-gallery-thumbs]');
  if (!wrap) return;

  function mediaVanSelectie() {
    // Er staan twee JSON-blokken op de pagina: het bootstrap-blok met een enkele
    // image per product, en het volledige products-blok met de hele media-lijst.
    // We nemen het blok dat daadwerkelijk media bevat.
    var titel = root.querySelector('[data-bdp-selected-title]');
    var naam = titel ? titel.textContent.trim().replace(/^MBA Tools \u2013 /, '') : ''; // LAYOUT-3COL: the title shows "MBA Tools – <format>"
    var nodes = document.querySelectorAll('[data-bdp-products-json], [data-bdp-initial-selection-json]');
    var beste = null;
    for (var n = 0; n < nodes.length; n++) {
      var cfg;
      try {
        cfg = JSON.parse(nodes[n].textContent || '{}');
        if (window.BizDecksExpandMedia) cfg = window.BizDecksExpandMedia(cfg);
      } catch (e) { continue; }
      var lijst = (cfg && cfg.products) || [];
      for (var i = 0; i < lijst.length; i++) {
        var pr = lijst[i];
        if (!pr || !pr.media || pr.media.length < 2) continue;
        if (pr.title === naam) return pr.media;
        if (!beste) beste = pr.media;
      }
    }
    return beste;
  }

  function bouw() {
    var media = mediaVanSelectie();
    if (!media || media.length < 2) { wrap.hidden = true; wrap.innerHTML = ''; return; }
    // Niet aftoppen op het aantal bolletjes: die worden bij een productwissel iets
    // later opnieuw opgebouwd, en dan zou de strook op het vorige product blijven hangen.
    var n = media.length;
    wrap.innerHTML = '';
    for (var i = 0; i < n; i++) {
      var m = media[i];
      var bron = m && (m.thumb || m.srcTiny || m.src || m.u);
      if (!bron) continue;
      // V36: een miniatuur is 48 css-px; 180 px breed inladen kost drie keer zoveel
      // bytes als nodig. 96 px is scherp op een gewoon telefoonscherm.
      bron = bron.replace(/([?&]width=)\d+/, '$196');
      var knop = document.createElement('button');
      knop.type = 'button';
      knop.setAttribute('data-bd-thumb-index', String(i));
      knop.setAttribute('aria-label', 'Show image ' + (i + 1) + ' of ' + n);
      var img = document.createElement('img');
      // alleen de eerste acht meteen; de rest komt binnen zodra je scrolt,
      // zodat ze geen bandbreedte afpakken van de hoofdafbeelding
      if (i < 8) { img.src = bron; } else { img.dataset.bdSrc = bron; }
      img.alt = '';
      img.loading = 'lazy';
      img.decoding = 'async';
      img.width = 54; img.height = 54;
      knop.appendChild(img);
      wrap.appendChild(knop);
    }
    wrap.hidden = wrap.children.length < 2;
    vulBij();
    markeer();
  }

  // Load thumbnails near the horizontal viewport, never all after a timer.
  var thumbnailObserver = null;
  function vulAfbeelding(img) {
    if (!img || !img.hasAttribute('data-bd-src')) return;
    img.src = img.getAttribute('data-bd-src'); img.removeAttribute('data-bd-src');
  }
  function vulZichtbare() {
    var viewport = wrap.getBoundingClientRect();
    wrap.querySelectorAll('img[data-bd-src]').forEach(function (img) {
      var rect = img.parentElement.getBoundingClientRect();
      if (rect.right >= viewport.left - 160 && rect.left <= viewport.right + 160) vulAfbeelding(img);
    });
  }
  function vulBij() {
    if (thumbnailObserver) thumbnailObserver.disconnect();
    if (typeof window.IntersectionObserver === 'function') {
      thumbnailObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { if (entry.isIntersecting) { vulAfbeelding(entry.target); thumbnailObserver.unobserve(entry.target); } });
      }, {root: wrap, rootMargin: '0px 160px', threshold: 0});
      wrap.querySelectorAll('img[data-bd-src]').forEach(function (img) { thumbnailObserver.observe(img); });
    } else vulZichtbare();
  }
  wrap.addEventListener('scroll', function () { if (!thumbnailObserver) vulZichtbare(); }, {passive: true});
  window.addEventListener('resize', function () { if (!thumbnailObserver) vulZichtbare(); }, {passive: true});

  function markeer() {
    var dots = root.querySelectorAll('[data-bdp-gallery-dot]');
    var actief = -1;
    for (var i = 0; i < dots.length; i++) {
      if (dots[i].getAttribute('aria-current') === 'true' || dots[i].classList.contains('is-active')) { actief = i; break; }
    }
    var knoppen = wrap.children;
    for (var j = 0; j < knoppen.length; j++) {
      knoppen[j].setAttribute('aria-current', j === actief ? 'true' : 'false');
    }
  }

  wrap.addEventListener('click', function (event) {
    var knop = event.target instanceof Element ? event.target.closest('[data-bd-thumb-index]') : null;
    if (!knop) return;
    vulAfbeelding(knop.querySelector('img'));
    var index = parseInt(knop.getAttribute('data-bd-thumb-index'), 10);
    var dots = root.querySelectorAll('[data-bdp-gallery-dot]');
    if (dots[index]) dots[index].click();
  });

  var titel = root.querySelector('[data-bdp-selected-title]');
  var herbouwTimer = 0;
  function herbouwStraks() {
    if (herbouwTimer) window.clearTimeout(herbouwTimer);
    herbouwTimer = window.setTimeout(bouw, 250);
  }
  if (titel && window.MutationObserver) {
    new MutationObserver(herbouwStraks).observe(titel, { childList: true, characterData: true, subtree: true });
  }
  var dotsWrap = root.querySelector('[data-bdp-gallery-dots]');
  if (dotsWrap && window.MutationObserver) {
    new MutationObserver(markeer).observe(dotsWrap, { attributes: true, subtree: true, attributeFilter: ['aria-current', 'class'] });
  }

  // V36: pas bouwen als de browser niets belangrijkers te doen heeft, zodat de
  // strook nooit concurreert met de hoofdafbeelding (LCP).
  function bouwStraks() {
    if (window.requestIdleCallback) window.requestIdleCallback(bouw, { timeout: 2500 });
    else window.setTimeout(bouw, 1200);
  }
  if (document.readyState === 'complete') bouwStraks();
  else window.addEventListener('load', bouwStraks, { once: true });
})();
})();
